import { render, staticRenderFns } from "./plan-pricing.vue?vue&type=template&id=4644a096&"
import script from "./plan-pricing.vue?vue&type=script&lang=js&"
export * from "./plan-pricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports